import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import DescriptionConent from "../Description-Content";

import "./index.css";

export default function DescriptionContainer(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const [descriptionID, setDescriptionID] = useState("start");
  const [min, setMin] = useState(null);
  const [max, setMax] = useState(null);
  const [hasFocused, setHasFocused] = useState(false);

  useEffect(() => {
    props.updateCurrentDescription(descriptionID);
    props.setAriaHideSplashScreens(descriptionID);
  }, [descriptionID]);

  useEffect(() => {
    // Check if description needs to update
    const descriptions = props.sceneData.Scrolly.descriptions;
    for (let i = 0; i < descriptions.length; i++) {
      let minimum = toSeconds(descriptions[i].range.min);
      let maximum = toSeconds(descriptions[i].range.max);
      minimum = (minimum / props.totalTime) * 100;
      maximum = (maximum / props.totalTime) * 100;
      if (props.percentage === 0 && descriptionID !== "start") {
        setDescriptionID("start");
      } else if (props.percentage === 100 && descriptionID !== "end") {
        setDescriptionID("end");
      } else if (
        minimum <= props.percentage &&
        props.percentage < maximum &&
        descriptions[i].id !== descriptionID
      ) {
        setDescriptionID(descriptions[i].id);
        setMin(minimum);
        setMax(maximum);
        props.updateCurrentDescription(descriptions[i].id);
      }
    }
  }, [props.percentage]);

  useEffect(() => {
    document.body.style.overflowY = props.scrollActive ? "scroll" : "hidden";
  }, [props.scrollActive]);

  const toSeconds = (timeStamp) => {
    // "00:00.00" (minutes:seconds) to seconds for percentage calculations and comparisons
    const timeArr = timeStamp.split(":");
    const seconds = Number(timeArr[0]) * 60 + Number(timeArr[1]);
    return seconds;
  };

  const updateDescriptionID = (bool) => {
    setDescriptionID(bool);
  };

  useEffect(() => {
    if (!hasFocused) {
      setHasFocused(true);
      return;
    }
    if (props.currentDescriptionID === "start") {
      const startScreen = document.getElementById("start-screen");
      if (startScreen) startScreen.focus();
    } else if (props.currentDescriptionID === "end") {
      const endScreen = document.getElementById("end-screen");
      if (endScreen) endScreen.focus();
    } else {
      const srSection = document.getElementById("focus-header");
      if (srSection) {
        srSection.focus();
      }
    }
  }, [props.currentDescriptionID]);

  return (
    <div
      id="description-container"
      className="description-container"
      tabIndex={-1}
      style={{
        display:
          descriptionID === null
            ? "none"
            : props.bp !== "lg" && props.bp !== "xl"
              ? null
              : "flex",
        margin: props.bp !== "lg" && props.bp !== "xl" ? null : "0px 32px",
        justifyContent:
          props.bp !== "lg" && props.bp !== "xl" ? null : "center",
        alignItems: props.bp !== "lg" && props.bp !== "xl" ? null : "center",
        top: props.bp !== "lg" && props.bp !== "xl" ? "12px" : null,
        marginLeft:
          props.bp !== "lg" && props.bp !== "xl" ? "calc(12px * 5)" : null,
        minWidth: props.bp !== "lg" && props.bp !== "xl" ? null : "354px",
        height: props.bp !== "lg" && props.bp !== "xl" ? "fit-content" : null,
      }}
    >
      <div
        className="sr-only"
        id="sr-only-current-section"
        aria-live="assertive"
        tabIndex={-1}
        role="note"
      >{`${t("currentSection.string")}: ${descriptionID}`}</div>
      <div id="focus-header" tabIndex={-1} className="sr-only"></div>
      {/* Description content display conditions */}
      {descriptionID !== "start" &&
      descriptionID !== "end" &&
      min <= props.percentage &&
      props.percentage <= max ? (
        <DescriptionConent
          // Contains description text/highlights/widgets
          sceneData={props.sceneData}
          descriptionID={props.currentDescriptionID}
          setDescriptionID={updateDescriptionID}
          bp={props.bp}
          percentage={props.percentage}
          forceAnimationTo={props.forceAnimationTo}
          forceScroll={props.forceScroll}
          totalTime={props.totalTime}
          scrollActive={props.scrollActive}
          setScrollActive={props.setScrollActive}
          plotFunctions={props.plotFunctions}
          debug={props.debug}
          preview={props.preview}
        />
      ) : null}
    </div>
  );
}
